import { gql } from '@apollo/client';

export const GET_RECHARGE_RECORDS = gql`
    query GetPortalRechargeRecords($startDate: LocalDate, $endDate: LocalDate, $timezone: String, $page: Int, $size: Int) {
        portalRechargeRecords(startDate: $startDate, endDate: $endDate, timezone: $timezone, page: $page, size: $size) {
            content {
                id
                rechargeTime
                rechargeAmount
                currency
            }
            totalElements
            totalPages
            page
            size
        }
    }
`;
